document.addEventListener('DOMContentLoaded', function() {
  const toggleButtons = document.querySelectorAll('.seo-text-toggle');
  
  toggleButtons.forEach(button => {
    // Setze initialen Text
    button.textContent = 'Text aufklappen';
    
    button.addEventListener('click', function() {
      const productDescription = this.closest('.product-description');
      const seoText = productDescription.querySelector('.seo-text');
      
      if (seoText) {
        // Toggle active Klasse
        seoText.classList.toggle('active');
        
        // Ändere Button Text
        if (seoText.classList.contains('active')) {
          this.textContent = 'Text einklappen';
        } else {
          this.textContent = 'Text aufklappen';
        }
      }
    });
  });
});